import { learningPathsChanged } from 'src/v3/profile/profile.slice'

export let resetCreateEntityOnEdit =
  // eslint-disable-next-line consistent-return
  (store: any) => (next: any) => (action: any) => {
    if (action.type === 'create/fetchLearningPaths/fulfilled') {
      store.dispatch(learningPathsChanged())
    }

    if (action) {
      return next(action)
    }
  }